module["exports"] = [
    "Aleea",
    "Bulevardul",
    "Intrarea"
];
